import { createAction, props } from '@ngrx/store';

export const payer = createAction('payer', props<{ data: any }>());

export const ship_tos = createAction('ship_tos', props<{ data: any }>());

export const plant = createAction('plant', props<{ data: any }>());

export const deliveryDetails = createAction(
  'deliveryDetails',
  props<{ data: any }>()
);

export const deliveryDetailsMaster = createAction(
  'deliveryDetailsMaster',
  props<{ data: any }>()
);

export const local_purchase_number = createAction(
  'local_purchase_number',
  props<{ data: any }>()
);

export const products = createAction('products', props<{ data: any }>());

export const setCart = createAction('setCart', props<{ data: any }>());

export const inco_term = createAction('inco_term', props<{ data: any }>());

export const setProductsAction = createAction(
  'setProductsAction',
  props<{ data: any }>()
);

//rotation
export const setrotationCart = createAction(
  'setrotationCart',
  props<{ data: any }>()
);
